import { render, staticRenderFns } from "./ElasticForceViz.vue?vue&type=template&id=542733d2&scoped=true"
import script from "./ElasticForceViz.vue?vue&type=script&lang=js"
export * from "./ElasticForceViz.vue?vue&type=script&lang=js"
import style0 from "./ElasticForceViz.vue?vue&type=style&index=0&id=542733d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542733d2",
  null
  
)

export default component.exports